import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {Map, MapMarker} from './map';
import styles from './styles.module.css';
import { MdEmail, MdLocationOn, MdCall} from "react-icons/md";
import { getEmailsList, getPhonesList, getAddressesList, isLoadingContacts } from '../../shared/state/contacts/selectors';


class ContactsPage extends Component{

    mapContainer = () => (
        <div className={styles.mapContainer}></div>
    )

    mapElement = () => (
        <div className={styles.mapElement}></div>
    )

    loadingElement = () => (
        <div className={styles.loadingElement}></div>
    )

    renderContactInfo = () => {
        const {
            emails = [
                {name: "geral", email: "fpsosusa91@gmail.cm"},
                {name: "geral", email: "fpsosusa91@gmail.cm"}
            ], 
            addresses=[
                {name: "Escritorio", address: "Rua Dr. Henrique Botelho, Edificio Jualfa Loja nº 6 Vila Pouca de Aguiar 5450-020 Vila Pouca de Aguiar"},
                {name: "Loja", address: "Rua Dr. Henrique Botelho, Edificio Jualfa Loja nº 6 Vila Pouca de Aguiar 5450-020 Vila Pouca de Aguiar"}
            ], 
            phones=[
                {name: "geral", phone: "937588750"},
                {name: "geral", phone: "934405929"}
            ], 
            socials=[]
        } = this.props;

        return (
            <React.Fragment>
            <div className={styles.contactPhones}>
              {
                  phones.map(({phone, name}, index) => 
                      <div
                          key={index}
                          className={classnames(styles.contact, styles.contactEmail)}>
                          <div className={styles.contactIcon}>
                              <MdCall/>
                          </div>
                          <div className={styles.contactContent}>
                              <div className={styles.contactLabel}>
                                  <div className={styles.contactLabelContent}>
                                      {name}
                                  </div>
                              </div>
                              <div className={styles.contactValue}>
                                  {phone}
                              </div>
                          </div>
                      </div>
                  )
              }
          </div>
            <div className={styles.contactAddresses}>
                {
                    addresses.map(({address, name}, index) => 
                        <div
                            key={index}
                            className={classnames(styles.contact, styles.contactEmail)}>
                            <div className={styles.contactIcon}>
                                <MdLocationOn/>
                            </div>
                            <div className={styles.contactContent}>
                                <div className={styles.contactLabel}>
                                    <div className={styles.contactLabelContent}>
                                        {name}
                                    </div>
                                </div>
                                <div className={styles.contactValue}>
                                    {address}
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
            <div className={styles.contactEmails}>
            {
                emails.map(({email, name}, index) => 
                    <div
                        key={index}
                        className={classnames(styles.contact, styles.contactEmail)}>
                        <div className={styles.contactIcon}>
                            <MdEmail/>
                        </div>
                        <div className={styles.contactContent}>
                            <div className={styles.contactLabel}>
                                <div className={styles.contactLabelContent}>
                                    {name}
                                </div>
                            </div>
                            <div className={styles.contactValue}>
                                {email}
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
        </React.Fragment>
        )
    }


    render = () => (
        <div className={styles.main}>
            <div className={styles.map}>
                <Map 
                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBJ_lK5aVtWxk7Ye2PYnwgLmsXHrAOQRLQ"
                    containerElement={this.mapContainer()}
                    mapElement={this.mapElement()}
                    loadingElement={this.loadingElement()}
                    centerCoordinates={{ lat: 41.4999637, lng: -7.640 }}>

                    <MapMarker position={{ lat: 41.4999637, lng: -7.6424 }}/>
                </Map>


                <div className={styles.contactsInfoWrapper}>
                    <div className={styles.contactsInfo}>
                        {this.renderContactInfo()}
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = () => {
    return (state) => ({
        isLoadingContacts: isLoadingContacts(state),
        emails: getEmailsList(state), 
        addresses: getAddressesList(state), 
        phones: getPhonesList(state), 
    });
};

export default connect(mapStateToProps)(ContactsPage);